import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-components"
}
const _hoisted_2 = { class: "label" }
const _hoisted_3 = {
  key: 0,
  class: "remind-ball"
}
const _hoisted_4 = { class: "image-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "form-components",
      style: {"margin":"0"}
    }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "form-components",
      style: {"margin":"0","flex":"unset"}
    }, null, -1)),
    (_ctx.item&&!((_ctx.item.field=='business_license'&&_ctx.signMode!=1)||(_ctx.item.field=='protocol_photos'&&_ctx.signMode==1)))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.item.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.item.name), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createBlock(_component_el_image, {
              key: _ctx.image,
              src: _ctx.image,
              fit: _ctx.fit
            }, null, 8, ["src", "fit"]))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}